import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk"
import { TracingInstrumentation } from "@grafana/faro-web-tracing"

export const faro = import.meta.env.DEV
  ? undefined
  : initializeFaro({
      url: "https://faro-collector-prod-eu-west-2.grafana.net/collect/9b61000a1ee50190b8216be9fa0e3c63",
      app: {
        name: "atlant-app",
        environment: import.meta.env.VITE_ENVIRONMENT,
      },
      instrumentations: [
        ...getWebInstrumentations({ captureConsole: true }),
        new TracingInstrumentation(),
      ],
    })
